import { CheckBoxOutlineBlank, CheckBoxOutlined } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import {
  Alert,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  Paper,
  Snackbar,
  TextareaAutosize,
  Typography,
  useMediaQuery,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import CustomConfirmationDialog from "../../../CustomComponents/CustomConfirmationDialog";
import CustomDateField from "../../../CustomComponents/CustomDateField";
import CustomDropDown from "../../../CustomComponents/CustomDropDown";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import { SpecialAccessDetailAction } from "../../../Store/SpecialAccess/SpecialAccessDetailReducer";
import BalanceTransfer from "./BalanceTransfer";
import { CommonShortCutAction } from "../../../Store/CommonShortCutsReducer";
import { DisbursementBalanceTransferReducerAction } from "../../../Store/DisbursementBalanceTransfer/DisbursementBalanceTransferReducer";
import store from "../../../Store";

const DisbursementDetailsTab = (props) => {
  var today = new Date();
  var currentDateValue = new Date(today.setHours(0, 0, 0, 0));

  const [feddValues, setfeddValues] = useState([]);
  const [showRemarksExpand, setshowRemarksExpand] = useState(false);
  const [remarksContent, setremarksContent] = useState("");
  const [remarksDialogTitle, setremarksDialogTitle] = useState("Remarks");
  const modeAccessMap = useSelector(
    (state) => state.specialAccess.modeAccessMap
  );
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);

  const fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  const dispatch = useDispatch();
  const losCustomerData = useSelector(
    (state) => state.disbursementLosCustomerData.losCustomerData
  );
  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);

  const validateDate = (date) => {
    let formattedValue = date;
    const minDateinvalid =
      new Date(formattedValue).toDateString() !== "Invalid Date" &&
      formattedValue !== null &&
      new Date(formattedValue).toLocaleDateString().slice(-4) >=
        String(
          new Date(
            new Date().setDate(new Date().getDate() - minDateValue)
          ).getFullYear()
        ) &&
      // min date validation.
      new Date(formattedValue) >=
        new Date(
          dayjs(
            new Date(new Date().setDate(new Date().getDate() - minDateValue))
          ).format("MM/DD/YYYY")
        )
        ? false
        : true;

    const maxDateInvalid =
      new Date(formattedValue).toDateString() !== "Invalid Date" &&
      formattedValue !== null &&
      // max date validation.
      new Date(formattedValue).toLocaleDateString().slice(-4) <=
        String(
          new Date(
            new Date().setDate(new Date().getDate() + maxDateValue)
          ).getFullYear()
        ) &&
      new Date(formattedValue) <=
        new Date(
          dayjs(
            new Date(new Date().setDate(new Date().getDate() + maxDateValue))
          ).format("MM/DD/YYYY")
        )
        ? false
        : true;
    if (
      new Date(formattedValue).toDateString() === "Invalid Date" &&
      formattedValue !== null &&
      formattedValue !== undefined
    ) {
      props.errordispatchEvent({
        type: props.errorParameters.dateOfDisbError,
        value: [true, "Please Enter Valid Disbursement Date"],
      });
    } else if (minDateinvalid && formattedValue !== null) {
      props.errordispatchEvent({
        type: props.errorParameters.dateOfDisbError,
        value: [
          true,
          "Date of Disbursement Cannot be lesser than Request Date Back count from Current Date.",
        ],
      });
    } else if (maxDateInvalid && formattedValue !== null) {
      props.errordispatchEvent({
        type: props.errorParameters.dateOfDisbError,
        value: [
          true,
          "Date of Disbursement Cannot be greater than Request Date Future count from Current Date.",
        ],
      });
    } else if (formattedValue === null || formattedValue === undefined) {
      props.errordispatchEvent({
        type: props.errorParameters.dateOfDisbError,
        value: [true, "Date of Disbursement Cannot be Empty."],
      });
    } else {
      props.errordispatchEvent({
        type: props.errorParameters.dateOfDisbError,
        value: [false, ""],
      });
    }
    props.dispatchEvent({
      type: props.screenFields.dateOfDisb,
      value: formattedValue,
    });
    if (props.disbursementDetailTabValue.disbCycleNum === 1) {
      props.dispatchEvent({
        type: props.screenFields.emiCommDate,
        value: formattedValue,
      });
      props.dispatchEvent({
        type: props.screenFields.firstEmiDueDate,
        value: "-1",
      });
      props.dispatchEvent({
        type: props.screenFields.billDay,
        value: "-1",
      });
      props.dispatchEvent({
        type: props.screenFields.billingDate,
        value: "",
      });
      getFEDDValues(date);
    }
  };

  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    if (event.ctrlKey) {
      if (charCode === "o" && maxDateValue > 0) {
        date.setDate(date.getDate() + 1);
        validateDate(date);
      } else if (charCode === "p" && minDateValue > 0) {
        date.setDate(date.getDate() - 1);
        validateDate(date);
      } else if (charCode === "i") {
        validateDate(date);
      }
    }
  };
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "disbursementCreate",
        })
      );
    }
  };

  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    switch (props.screenMode) {
      case "CREATE":
        modeIdVal = "DB01-C";
        break;
      case "VIEW":
        modeIdVal = "DB02-V";
        break;
      case "MODIFY":
        modeIdVal = "DB02-M";
        break;
      case "CANCEL":
        modeIdVal = "DB02-C";
        break;
      default:
        break;
    }
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateValue = Number(0);
  let maxDateValue = Number(0);
  if (
    props.parameterValues !== null &&
    props.parameterValues !== undefined &&
    Object.keys(props.parameterValues).length > 0
  ) {
    if (props.screenMode === "CREATE") {
      minDateValue =
        fieldAccessMap &&
        (fieldAccessMap.disbursementCreateRequestDateBackCount &&
        props.parameterValues["Disbursement Create Request Date Back Count"]
          ? Number(
              props.parameterValues[
                "Disbursement Create Request Date Back Count"
              ]["paramValue"]
            )
          : 0);
      maxDateValue =
        fieldAccessMap &&
        (fieldAccessMap.disbursementCreateRequestDateFutureCount &&
        props.parameterValues["Disbursement Create Request Date Future Count"]
          ? Number(
              props.parameterValues[
                "Disbursement Create Request Date Future Count"
              ]["paramValue"]
            )
          : 0);
      // checking for the current date is between effective start & end dates, if not enable only current date.
      const parameterValues = props.parameterValues;
      if (parameterValues && Object.keys(parameterValues).length > 0) {
        if (
          !(
            parameterValues["Disbursement Create Request Date Future Count"] &&
            new Date(
              parameterValues["Disbursement Create Request Date Future Count"][
                "paramEffStartDate"
              ]
            ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
            new Date(
              parameterValues["Disbursement Create Request Date Future Count"][
                "paramEffEndDate"
              ]
            ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
          )
        ) {
          maxDateValue = 0;
        }

        if (
          !(
            parameterValues["Disbursement Create Request Date Back Count"] &&
            new Date(
              parameterValues["Disbursement Create Request Date Back Count"][
                "paramEffStartDate"
              ]
            ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
            new Date(
              parameterValues["Disbursement Create Request Date Back Count"][
                "paramEffEndDate"
              ]
            ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
          )
        ) {
          minDateValue = 0;
        }
      }
    } else if (props.screenMode === "MODIFY") {
      minDateValue =
        fieldAccessMap &&
        (fieldAccessMap.requestDateModifyBackCount &&
        props.parameterValues["Disbursement Modify Request Date Back Count"]
          ? Number(
              props.parameterValues[
                "Disbursement Modify Request Date Back Count"
              ]["paramValue"]
            )
          : 0);
      maxDateValue =
        fieldAccessMap &&
        (fieldAccessMap.requestDateModifyFutureCount &&
        props.parameterValues["Disbursement Modify Request Date Future Count"]
          ? Number(
              props.parameterValues[
                "Disbursement Modify Request Date Future Count"
              ]["paramValue"]
            )
          : 0);

      // checking for the current date is between effective start & end dates, if not enable only current date.
      const parameterValues = props.parameterValues;
      if (parameterValues && Object.keys(parameterValues).length > 0) {
        if (
          !(
            parameterValues["Disbursement Modify Request Date Future Count"] &&
            new Date(
              parameterValues["Disbursement Modify Request Date Future Count"][
                "paramEffStartDate"
              ]
            ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
            new Date(
              parameterValues["Disbursement Modify Request Date Future Count"][
                "paramEffEndDate"
              ]
            ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
          )
        ) {
          maxDateValue = 0;
        }

        if (
          !(
            parameterValues["Disbursement Modify Request Date Back Count"] &&
            new Date(
              parameterValues["Disbursement Modify Request Date Back Count"][
                "paramEffStartDate"
              ]
            ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
            new Date(
              parameterValues["Disbursement Modify Request Date Back Count"][
                "paramEffEndDate"
              ]
            ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
          )
        ) {
          minDateValue = 0;
        }
      }
    }
  }
  const disableAllFields = props.screenMode === "VIEW";

  const getFEDDValues = (dateofDisbursement) => {
    if (dateofDisbursement) {
      var disbDate = new Date(dateofDisbursement);
      if (String(disbDate) !== "Invalid Date") {
        var option1 = dayjs(
          new Date(disbDate.getFullYear(), disbDate.getMonth() + 1, 0)
        ).format("DD/MM/YYYY");

        var option2 = dayjs(
          new Date(disbDate.getFullYear(), disbDate.getMonth() + 2, 0)
        ).format("DD/MM/YYYY");
        const dataMap = [
          { value: option1, text: option1 },
          { value: option2, text: option2 },
        ];
        setfeddValues(dataMap);
      }
    }
  };

  const onbillDayChange = (event) => {
    var value = event.target.value;
    // validate the billing date with current system date & update the fedd values.
    // when date of disbursement is null or empty don't show suggestions.
    if (!value || value === "-1" || value === "") {
      // setfeddValues([]);
      props.dispatchEvent({
        type: props.screenFields.billDay,
        value: null,
      });
      props.dispatchEvent({
        type: props.screenFields.firstEmiDueDate,
        value: "",
      });
      props.dispatchEvent({
        type: props.screenFields.billingDate,
        value: "",
      });
      props.errordispatchEvent({
        type: props.errorParameters.billDayError,
        value: [true, "Please Select Billing Day."],
      });
    } else {
      props.errordispatchEvent({
        type: props.errorParameters.billDayError,
        value: [false, "Please Select Billing Day."],
      });
    }

    if (props.disbursementDetailTabValue.dateOfDisb) {
      let billingDateValue = value;
      var disbDate = new Date(props.disbursementDetailTabValue.dateOfDisb);
      if (String(disbDate) !== "Invalid Date") {
        const disbDateMonthLastDay = new Date(
          disbDate.getFullYear(),
          disbDate.getMonth() + 1,
          0
        );

        if (
          billingDateValue &&
          billingDateValue !== "-1" &&
          billingDateValue <= disbDateMonthLastDay.getDate()
        ) {
          if (
            new Date(disbDate.toDateString()) >=
            new Date(new Date().toDateString())
          ) {
            // future date count.
            if (disbDate.getDate() <= billingDateValue) {
              // disb date <= billing day.
              var option1 = dayjs(
                new Date(disbDate.getFullYear(), disbDate.getMonth() + 1, 0)
              ).format("DD/MM/YYYY");
              var option2 = dayjs(
                new Date(disbDate.getFullYear(), disbDate.getMonth() + 2, 0)
              ).format("DD/MM/YYYY");
            } else if (disbDate.getDate() > billingDateValue) {
              // disb date > billing day.
              var option2 = dayjs(
                new Date(disbDate.getFullYear(), disbDate.getMonth() + 2, 0)
              ).format("DD/MM/YYYY");
            }
          } else if (disbDate.getDate() <= billingDateValue) {
            var option1 = dayjs(
              new Date(disbDate.getFullYear(), disbDate.getMonth() + 1, 0)
            ).format("DD/MM/YYYY");
            var option2 = dayjs(
              new Date(disbDate.getFullYear(), disbDate.getMonth() + 2, 0)
            ).format("DD/MM/YYYY");
          } else if (disbDate.getDate() >= billingDateValue) {
            var option2 = dayjs(
              new Date(disbDate.getFullYear(), disbDate.getMonth() + 2, 0)
            ).format("DD/MM/YYYY");
          }
        } else {
          // when billing day > disbursement date month last date.
          // Ex : billing day is 31 when disb date is April 30.
          // in this case auto set the billing day to disb date month last date.
          setMessage(
            "Billing Day Value greater than Last Date value of the Disbursement Date Month. So Changing Billing Day to Last Date"
          );
          setAlertType("error");
          openAlertHandler();
          billingDateValue = disbDateMonthLastDay.getDate();
          if (
            new Date(disbDate.toDateString()) >=
            new Date(new Date().toDateString())
          ) {
            // future date count.
            if (disbDate.getDate() <= billingDateValue) {
              // disb date <= billing day.
              var option1 = dayjs(
                new Date(disbDate.getFullYear(), disbDate.getMonth() + 1, 0)
              ).format("DD/MM/YYYY");
              var option2 = dayjs(
                new Date(disbDate.getFullYear(), disbDate.getMonth() + 2, 0)
              ).format("DD/MM/YYYY");
            } else if (disbDate.getDate() > billingDateValue) {
              // disb date > billing day.
              var option2 = dayjs(
                new Date(disbDate.getFullYear(), disbDate.getMonth() + 2, 0)
              ).format("DD/MM/YYYY");
            }
          } else if (disbDate.getDate() <= billingDateValue) {
            var option1 = dayjs(
              new Date(disbDate.getFullYear(), disbDate.getMonth() + 1, 0)
            ).format("DD/MM/YYYY");
            var option2 = dayjs(
              new Date(disbDate.getFullYear(), disbDate.getMonth() + 2, 0)
            ).format("DD/MM/YYYY");
          } else if (disbDate.getDate() >= billingDateValue) {
            var option2 = dayjs(
              new Date(disbDate.getFullYear(), disbDate.getMonth() + 2, 0)
            ).format("DD/MM/YYYY");
          }
        }

        const dataMap = [];

        if (option1) {
          dataMap.push({ value: option1, text: option1 });
        }
        if (option2) {
          dataMap.push({ value: option2, text: option2 });
        }

        setfeddValues(dataMap);
      }

      props.dispatchEvent({
        type: props.screenFields.billDay,
        value: billingDateValue,
      });
      // on bill day change reset the value fedd value to empty, since the values updates.
      // this is the easiest option instead of writing a complex validation to check.
      props.dispatchEvent({
        type: props.screenFields.firstEmiDueDate,
        value: "",
      });
      //reset to empty and set updated value.
      props.dispatchEvent({
        type: props.screenFields.billingDate,
        value: "",
      });
      setBillingDate(value, "-1");
    }
  };

  const onFEDDChange = (event) => {
    var value = event.target.value;
    if (!value || value === "" || value === "-1") {
      props.dispatchEvent({
        type: props.screenFields.firstEmiDueDate,
        value: "",
      });
      props.dispatchEvent({
        type: props.screenFields.billingDate,
        value: "",
      });
      props.errordispatchEvent({
        type: props.errorParameters.feddError,
        value: [true, "Please Select FEDD Date."],
      });
    } else {
      props.errordispatchEvent({
        type: props.errorParameters.feddError,
        value: [false, "Please Select FEDD Date."],
      });
      props.dispatchEvent({
        type: props.screenFields.firstEmiDueDate,
        value: value,
      });
      setBillingDate(props.disbursementDetailTabValue.billDay, value);
    }
  };

  const setBillingDate = (billDay, fedd) => {
    if (billDay !== "-1" && fedd !== "-1") {
      let billingDate = new Date(
        Number(fedd.split("/")[2]),
        Number(fedd.split("/")[1]) - 1,
        Number(billDay)
      );

      let disbDate = new Date(props.disbursementDetailTabValue.dateOfDisb);
      if (disbDate > billingDate) {
        billingDate = new Date(
          Number(fedd.split("/")[2]),
          Number(fedd.split("/")[1]),
          Number(billDay)
        );
        var value = dayjs(billingDate).format("DD/MM/YYYY");
        props.dispatchEvent({
          type: props.screenFields.billingDate,
          value: value,
        });
      } else {
        var value = dayjs(billingDate).format("DD/MM/YYYY");
        props.dispatchEvent({
          type: props.screenFields.billingDate,
          value: value,
        });
      }
    }
  };

  useEffect(() => {
    // on initial page load -> load the Disbursement Module LOV Master Values.
    const getLovMasterData = async () => {
      const disbursementLovValues = await axios.post(
        "/lovMaster/getLovValues",
        {
          moduleId: "MD001",
        }
      );
      const lovData = disbursementLovValues.data;
      dispatch(
        DisbursementBalanceTransferReducerAction.updateLovDataValue(lovData)
      );
      const targetFieldsData = Object.keys(lovData);
      dispatch(
        DisbursementBalanceTransferReducerAction.updateLovTargetFields(
          targetFieldsData
        )
      );
    };
    getLovMasterData();
    if (props.disbursementDetailTabValue.disbCycleNum === 1) {
      getFEDDValues(props.disbursementDetailTabValue.dateOfDisb);
    } else {
      // when disb num > 1
      const dataMap = [
        {
          value: props.disbursementDetailTabValue.firstEmiDueDate,
          text: props.disbursementDetailTabValue.firstEmiDueDate,
        },
      ];
      setfeddValues(dataMap);
    }

  }, [props.disbursementDetailTabValue.totalDeductionAmt]);

  useEffect(() => {
    // we reload this tab value since the net disb change should update to amount field on grid on page load
    if (props.screenMode === "CREATE") {
      setDisbEmiAmt(props.disbursementDetailTabValue.disbAmt);
    }
  }, [losCustomerData, props.disbursementDetailTabValue.totalDeductionAmt]);

  const setDisbEmiAmt = (disbAmount) => {
    let time = losCustomerData.tenure;
    // yearly rate of interest
    let rateOfInterest = losCustomerData.rateOfInterest;
    props.dispatchEvent({
      type: props.screenFields.rateOfInterest,
      value: losCustomerData.rateOfInterest,
    });
    // monthly converted rate of interest
    rateOfInterest = rateOfInterest / (12 * 100);
    let montlyPayment =
      (disbAmount * rateOfInterest * Math.pow(1 + rateOfInterest, time)) /
      (Math.pow(1 + rateOfInterest, time) - 1);
    props.dispatchEvent({
      type: props.screenFields.disbEmiAmt,
      value: Math.ceil(montlyPayment),
    });
  };

  const removeUnwantedChars = (inputValue, typeValue) => {
    const regExpString =
      /^(?=\n)$|^\s*|^\s*$(?:\r\n?|\n)|\n\n+|\t|[^a-zA-Z0-9.,]|[%<>\\$'"{}\[\]]/gim;
    let formattedValue = String(inputValue).replace(regExpString, " ");
    // we need to remove twice since relaced space shouldbe removed
    formattedValue = String(formattedValue).replace(/[^\u0000-\u007F]+/, "");
    let finalValue = String(formattedValue).replace(regExpString, " ");
    finalValue = finalValue.replace(/\s+/g, " ");
    finalValue = finalValue.trimStart();
    // remove the starting space, comma, dot at starting position of string only.
    if (finalValue.startsWith(",") || finalValue.startsWith(".")) {
      finalValue = finalValue.replace(/,+/g, ",");
      finalValue = finalValue.replace(/,/, "");
      finalValue = finalValue.replace(/\.+/g, ".");
      finalValue = finalValue.replace(/\./, "");
    }
    props.dispatchEvent({
      type: typeValue,
      value: finalValue,
    });
  };
  const [disbursementDateDisable, setDisbursementDateDisable] = useState(false);

  useEffect(() => {
    if (props.screenMode === "CREATE") {
      if (!fieldAccessMap.disbursementDateCreate) {
        setDisbursementDateDisable(true);
      } else {
        setDisbursementDateDisable(false);
      }
    } else if (props.screenMode === "MODIFY") {
      if (!fieldAccessMap.disbursementDateModify) {
        setDisbursementDateDisable(true);
      } else {
        setDisbursementDateDisable(false);
      }
    } else {
      if (
        disableAllFields ||
        props.screenMode === "APPROVE" ||
        props.screenMode === "CANCEL"
      ) {
        setDisbursementDateDisable(true);
      } else {
        setDisbursementDateDisable(false);
      }
    }
  }, [fieldAccessMap]);

  const validateCurrentDisbAmtOnFocusOut = (newValue) => {
    let status = true;
    const data = { ...props.disbursementDetailTabValue };
    const errorState = { ...props.errorState };
    //Validating Current Disbursement Amount Field
    if (
      newValue === 0 ||
      newValue === null ||
      newValue === "" ||
      newValue === "0" ||
      newValue === "00"
    ) {
      props.errordispatchEvent({
        type: props.errorParameters.currentDisbError,
        value: [true, "Current Disbursement Amount Cannot be Zero."],
      });
      status = false;
    } else if (
      Math.floor(newValue + data.earlierDisbAmt) >
      Math.floor(losCustomerData.sanctionAmt)
    ) {
      props.errordispatchEvent({
        type: props.errorParameters.currentDisbError,
        value: [
          true,
          "Sum of Current Disbursement Amount & Earlier Disbursement Amount Cannot be Greater than Sanctioned Loan Amount.",
        ],
      });
      status = false;
    } else if (data.totalDisbAmt <= 0) {
      props.errordispatchEvent({
        type: props.errorParameters.currentDisbError,
        value: [
          true,
          "Current Disbursement Amount Cannot be Less than or Equal to Total Deductions.",
        ],
      });
      status = false;
    } else if (
      props.parameterValues &&
      Object.keys(props.parameterValues).length > 0 &&
      props.parameterValues["Disbursement Minimum Amount"] &&
      new Date(
        props.parameterValues["Disbursement Minimum Amount"][
          "paramEffStartDate"
        ]
      ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
      new Date(
        props.parameterValues["Disbursement Minimum Amount"]["paramEffEndDate"]
      ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
      Math.floor(data.disbAmt) <
        Number(
          props.parameterValues["Disbursement Minimum Amount"]["paramValue"]
        )
    ) {
      props.errordispatchEvent({
        type: props.errorParameters.currentDisbError,
        value: [
          true,
          "Current Disbursement Amount Cannot be Less than Minimum Disbursement Amount given in Parameter.",
        ],
      });
      status = false;
    } else if (errorState.currentDisbError[0]) {
      props.errordispatchEvent({
        type: props.errorParameters.currentDisbError,
        value: [false, "Current Disbursement Amount Cannot be Zero."],
      });
    }
  };

  return (
    <div>
      {
        <div>
          <Box sx={{ marginTop: "-1%" }}>
            <Grid container rowSpacing={0} columnSpacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={true}
                  required={false}
                  label="Disbursement Cycle Number"
                  id="disbursementNumber"
                  variant="standard"
                  value={props.disbursementDetailTabValue.disbCycleNum}
                  type="text"
                  placeholder="Enter Disbursement Number"
                />
              </Grid>
              {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            disabled={true}
            required={false}
            label="Earlier Disbursement Amount"
            id="earlierDisbursementAmount"
            variant="standard"
            value={parseInt(
              props.disbursementDetailTabValue.earlierDisbAmt
            ).toLocaleString("en-IN")}
            type="text" 
            placeholder="Enter Earlier Disbursement Amount"
          />
        </Grid> */}

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={
                    disableAllFields ||
                    props.screenMode === "APPROVE" ||
                    props.screenMode === "CANCEL"
                  }
                  required={true}
                  label="Current Disbursement Amount (₹)"
                  id="currentDisbursementAmount"
                  variant="standard"
                  value={
                    props.disbursementDetailTabValue.disbAmt === ""
                      ? 0
                      : parseInt(
                          props.disbursementDetailTabValue.disbAmt
                        ).toLocaleString("en-IN")
                  }
                  type="text"
                  placeholder="Enter Current Disbursement Amount"
                  onChange={(event, value) => {
                    const newValue = Math.floor(
                      event.target.value.replaceAll(",", "")
                    );
                    props.dispatchEvent({
                      type: props.screenFields.disbAmt,
                      value: isNaN(Number(newValue))
                        ? 0
                        : newValue < 0
                        ? 0
                        : newValue,
                    });
                    const totalNetDisbAmt =
                      parseInt(
                        isNaN(Number(newValue))
                          ? 0
                          : newValue < 0
                          ? 0
                          : newValue
                      ) - props.disbursementDetailTabValue.totalDeductionAmt;
                    props.dispatchEvent({
                      type: props.screenFields.totalDisbAmt,
                      value: totalNetDisbAmt < 0 ? 0 : totalNetDisbAmt,
                    });
                    setDisbEmiAmt(
                      isNaN(Number(newValue)) ? 0 : newValue < 0 ? 0 : newValue
                    );
                    if (newValue > 999999999) {
                      props.errordispatchEvent({
                        type: props.errorParameters.currentDisbError,
                        value: [
                          true,
                          "Current Disbursement Amount Cannot be greater than 99,99,99,999.",
                        ],
                      });
                    } else {
                      props.errordispatchEvent({
                        type: props.errorParameters.currentDisbError,
                        value: [false, ""],
                      });
                    }
                  }}
                  onBlur={(event, value) => {
                    let newValue = Math.floor(
                      event.target.value.replaceAll(",", "")
                    );
                    newValue = isNaN(Number(newValue))
                      ? 0
                      : newValue < 0
                      ? 0
                      : newValue;
                    validateCurrentDisbAmtOnFocusOut(newValue);
                  }}
                  onFocus={(event, value) => {
                    let newValue = Math.floor(
                      event.target.value.replaceAll(",", "")
                    );
                    newValue = isNaN(Number(newValue))
                      ? 0
                      : newValue < 0
                      ? 0
                      : newValue;
                    const totalNetDisbAmt =
                      parseInt(
                        isNaN(Number(newValue))
                          ? 0
                          : newValue < 0
                          ? 0
                          : newValue
                      ) - props.disbursementDetailTabValue.totalDeductionAmt;
                    props.dispatchEvent({
                      type: props.screenFields.totalDisbAmt,
                      value: totalNetDisbAmt < 0 ? 0 : totalNetDisbAmt,
                    });
                  }}
                />
                {props.errorState.currentDisbError[0] && (
                  <p className="error">
                    {props.errorState.currentDisbError[1]}
                  </p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={true}
                  required={false}
                  label="Total Deductions (₹)"
                  id="deductions"
                  variant="standard"
                  value={parseInt(
                    props.disbursementDetailTabValue.totalDeductionAmt
                  ).toLocaleString("en-IN")}
                  type="text"
                  placeholder="Enter Total Deductions"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={true}
                  required={false}
                  label="Net Current Disbursement Amount (₹)"
                  id="netAmount"
                  variant="standard"
                  value={parseInt(
                    props.disbursementDetailTabValue.disbAmt -
                      props.disbursementDetailTabValue.totalDeductionAmt
                  ).toLocaleString("en-IN")}
                  type="text"
                  placeholder="Enter Net Disbursement Amount"
                />
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
          <CustomTextField
            disabled={true}
            required={false}
            label="Balance Amount"
            id="balanceAmount"
            variant="standard"
            value={parseInt(
              losCustomerData.sanctionAmt -
                props.disbursementDetailTabValue.earlierDisbAmt -
                props.disbursementDetailTabValue.disbAmt
            ).toLocaleString("en-IN")}
            type="text"
            placeholder="Enter Balance Amount"
          />
        </Grid> */}

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={true}
                  required={false}
                  label="Disbursement EMI (₹)"
                  id="disbEmi"
                  variant="standard"
                  value={parseInt(
                    props.disbursementDetailTabValue.disbEmiAmt
                  ).toLocaleString("en-IN")}
                  type="text"
                  placeholder=""
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={true}
                  required={false}
                  label="Tenure"
                  id="tenure"
                  variant="standard"
                  value={losCustomerData.tenure}
                  type="text"
                  placeholder=""
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={true}
                  required={false}
                  label="Rate of Interest(%)"
                  id="roi"
                  variant="standard"
                  value={losCustomerData.rateOfInterest}
                  type="text"
                  placeholder=""
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  disabled={disbursementDateDisable}
                  required={true}
                  label="Disbursement Date"
                  id="disbursementDate"
                  variant="standard"
                  value={props.disbursementDetailTabValue.dateOfDisb}
                  maxDate={new Date().setDate(
                    new Date().getDate() + maxDateValue
                  )}
                  minDate={new Date().setDate(
                    new Date().getDate() - minDateValue
                  )}
                  type="text"
                  placeholder=""
                  onChange={(event, value) => {
                    let formattedValue = event;
                    const minDateinvalid =
                      new Date(formattedValue).toDateString() !==
                        "Invalid Date" &&
                      formattedValue !== null &&
                      new Date(formattedValue).toLocaleDateString().slice(-4) >=
                        String(
                          new Date(
                            new Date().setDate(
                              new Date().getDate() - minDateValue
                            )
                          ).getFullYear()
                        ) &&
                      // min date validation.
                      new Date(formattedValue) >=
                        new Date(
                          dayjs(
                            new Date(
                              new Date().setDate(
                                new Date().getDate() - minDateValue
                              )
                            )
                          ).format("MM/DD/YYYY")
                        )
                        ? false
                        : true;

                    const maxDateInvalid =
                      new Date(formattedValue).toDateString() !==
                        "Invalid Date" &&
                      formattedValue !== null &&
                      // max date validation.
                      new Date(formattedValue).toLocaleDateString().slice(-4) <=
                        String(
                          new Date(
                            new Date().setDate(
                              new Date().getDate() + maxDateValue
                            )
                          ).getFullYear()
                        ) &&
                      new Date(formattedValue) <=
                        new Date(
                          dayjs(
                            new Date(
                              new Date().setDate(
                                new Date().getDate() + maxDateValue
                              )
                            )
                          ).format("MM/DD/YYYY")
                        )
                        ? false
                        : true;
                    if (
                      new Date(formattedValue).toDateString() ===
                        "Invalid Date" &&
                      formattedValue !== null &&
                      formattedValue !== undefined
                    ) {
                      props.errordispatchEvent({
                        type: props.errorParameters.dateOfDisbError,
                        value: [true, "Please Enter Valid Disbursement Date"],
                      });
                    } else if (minDateinvalid && formattedValue !== null) {
                      props.errordispatchEvent({
                        type: props.errorParameters.dateOfDisbError,
                        value: [
                          true,
                          "Date of Disbursement Cannot be lesser than Request Date Back count from Current Date.",
                        ],
                      });
                    } else if (maxDateInvalid && formattedValue !== null) {
                      props.errordispatchEvent({
                        type: props.errorParameters.dateOfDisbError,
                        value: [
                          true,
                          "Date of Disbursement Cannot be greater than Request Date Future count from Current Date.",
                        ],
                      });
                    } else if (
                      formattedValue === null ||
                      formattedValue === undefined
                    ) {
                      props.errordispatchEvent({
                        type: props.errorParameters.dateOfDisbError,
                        value: [true, "Date of Disbursement Cannot be Empty."],
                      });
                    } else {
                      props.errordispatchEvent({
                        type: props.errorParameters.dateOfDisbError,
                        value: [false, ""],
                      });
                    }
                    props.dispatchEvent({
                      type: props.screenFields.dateOfDisb,
                      value: formattedValue,
                    });
                    if (props.disbursementDetailTabValue.disbCycleNum === 1) {
                      props.dispatchEvent({
                        type: props.screenFields.emiCommDate,
                        value: formattedValue,
                      });
                      props.dispatchEvent({
                        type: props.screenFields.firstEmiDueDate,
                        value: "-1",
                      });
                      props.dispatchEvent({
                        type: props.screenFields.billDay,
                        value: "-1",
                      });
                      props.dispatchEvent({
                        type: props.screenFields.billingDate,
                        value: "",
                      });
                      getFEDDValues(event);
                    }
                  }}
                />
                {props.errorState.dateOfDisbError[0] && (
                  <p className="error">{props.errorState.dateOfDisbError[1]}</p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  disabled={true}
                  required={false}
                  label="ECD"
                  id="ecd"
                  variant="standard"
                  value={props.disbursementDetailTabValue.emiCommDate}
                  type="text"
                  placeholder=""
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDropDown
                  disabled={
                    disableAllFields ||
                    props.screenMode === "APPROVE" ||
                    props.screenMode === "CANCEL" ||
                    props.disbursementDetailTabValue.disbCycleNum !== 1
                  }
                  required={true}
                  label="Billing Day"
                  id="billDay"
                  variant="standard"
                  type="text"
                  placeholder="Select Billing Day"
                  dropDownValue={props.billDayValues}
                  value={props.disbursementDetailTabValue.billDay}
                  onChange={onbillDayChange}
                />
                {props.errorState.billDayError[0] && (
                  <p className="error">{props.errorState.billDayError[1]}</p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDropDown
                  disabled={
                    disableAllFields ||
                    props.screenMode === "APPROVE" ||
                    props.screenMode === "CANCEL" ||
                    props.disbursementDetailTabValue.disbCycleNum !== 1
                  }
                  required={true}
                  label="FEDD"
                  id="fedd"
                  variant="standard"
                  dropDownValue={feddValues}
                  value={props.disbursementDetailTabValue.firstEmiDueDate}
                  type="text"
                  placeholder="Select FEDD Date"
                  onChange={onFEDDChange}
                />
                {props.errorState.feddError[0] && (
                  <p className="error">{props.errorState.feddError[1]}</p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={true}
                  required={false}
                  label="Billing Date"
                  id="billingDate"
                  variant="standard"
                  value={props.disbursementDetailTabValue.billingDate}
                  type="text"
                  placeholder="Billing Date"
                />
              </Grid>

              {/* {props.screenMode !== "CREATE" ? (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Request Number"
              id="requestNumber"
              variant="standard"
              value={props.disbursementDetailTabValue.transactionKey}
              type="text"
              placeholder="Request Number"
            />
          </Grid>
        ) : null} */}

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={true}
                  required={false}
                  label="Request Status"
                  id="status"
                  variant="standard"
                  value={props.disbursementDetailTabValue.requestStatus}
                  type="text"
                  placeholder=""
                />
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomTextField
                  disabled={true}
                  required={false}
                  label="Payment Mode"
                  id="paymentMode"
                  variant="standard"
                  value={props.disbursementDetailTabValue.paymentMode}
                  type="text"
                  placeholder="Enter Payment Mode"
                />
              </Grid> */}

              {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}></Grid> */}

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <InputLabel
                  id="remarks"
                  sx={{
                    color: "#004A92",
                    marginTop: "8px",
                    fontWeight: 400,
                    fontSize: "0.875rem",
                  }}
                  required={props.screenMode === "CANCEL"}
                >
                  Remarks
                  <IconButton
                    color="primary"
                    aria-label="Info"
                    component="label"
                    disabled={props.disbursementDetailTabValue.remarks === ""}
                    onClick={() => {
                      setremarksDialogTitle("Remarks:");
                      setremarksContent(
                        props.disbursementDetailTabValue.remarks
                      );
                      setshowRemarksExpand(true);
                    }}
                  >
                    <InfoIcon />
                  </IconButton>
                </InputLabel>
                <TextareaAutosize
                  disabled={disableAllFields || props.screenMode === "APPROVE"}
                  id="remarks"
                  maxRows={3}
                  required={false}
                  value={props.disbursementDetailTabValue.remarks}
                  aria-label="maximum height"
                  onChange={(event, value) => {
                    removeUnwantedChars(
                      event.target.value,
                      props.screenFields.remarks
                    );
                  }}
                  style={{
                    width: "100%",
                    height: "50px",
                    borderRadius: "4px",
                    resize: "none",
                    outline: "none",
                    fontFamily: "inherit",
                    fontSize: "inherit",
                    overflow: "auto",
                  }}
                />
                {props.errorState.remarksError[0] && (
                  <p className="error">{props.errorState.remarksError[1]}</p>
                )}
              </Grid>

              {props.screenMode === "APPROVE" ||
              props.disbursementDetailTabValue.requestStatus === "Approved" ||
              props.disbursementDetailTabValue.requestStatus ===
                "Approved , Cheque HandOver Pending" ||
              props.disbursementDetailTabValue.requestStatus ===
                "Approved , Cheque Authourization Pending" ? (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <InputLabel
                    id="remarks"
                    sx={{
                      color: "#004A92",
                      marginTop: "8px",
                      fontWeight: 400,
                      fontSize: "0.875rem",
                    }}
                    required={true}
                  >
                    Approval Remarks
                    <IconButton
                      color="primary"
                      aria-label="Info"
                      component="label"
                      disabled={
                        props.disbursementDetailTabValue.approvalRemarks === ""
                      }
                      onClick={() => {
                        setremarksDialogTitle("Remarks:");
                        setremarksContent(
                          props.disbursementDetailTabValue.approvalRemarks
                        );
                        setshowRemarksExpand(true);
                      }}
                    >
                      <InfoIcon />
                    </IconButton>
                  </InputLabel>
                  <TextareaAutosize
                    id="approvalRemarks"
                    maxRows={4}
                    required={false}
                    value={props.disbursementDetailTabValue.approvalRemarks}
                    disabled={
                      disableAllFields ||
                      props.disbursementDetailTabValue.requestStatus ===
                        "Approved , Cheque HandOver Pending" ||
                      props.disbursementDetailTabValue.requestStatus ===
                        "Approved , Cheque Authourization Pending" ||
                      props.disbursementDetailTabValue.requestStatus ===
                        "Approved"
                    }
                    aria-label="maximum height"
                    onChange={(event, value) => {
                      removeUnwantedChars(
                        event.target.value,
                        props.screenFields.approvalRemarks
                      );
                    }}
                    style={{
                      width: "100%",
                      height: "50px",
                      borderRadius: "4px",
                      resize: "none",
                      outline: "none",
                      fontFamily: "inherit",
                      fontSize: "inherit",
                      overflow: "auto",
                    }}
                  />
                  {props.errorState.approvalRemarksError[0] && (
                    <p className="error">
                      {props.errorState.approvalRemarksError[1]}
                    </p>
                  )}
                </Grid>
              ) : null}
            </Grid>
            <CustomConfirmationDialog
              dialogOpen={showRemarksExpand}
              onDialogClose={() => {
                setshowRemarksExpand(false);
              }}
              dialogTitle={
                <Typography sx={{ color: "green" }}>
                  {remarksDialogTitle}
                </Typography>
              }
              dialogContent={<Typography>{remarksContent}</Typography>}
              hideCancelButton={true}
              okButtonName={"Close"}
              onOkClick={() => {
                setshowRemarksExpand(false);
              }}
            />
            <Box
              sx={{
                justifyContent: "center",
                margin: "auto",
              }}
            >
              <Paper sx={{ padding: "16px" }}>
                {props.errorState.bankAccountError[0] && (
                  <div style={{ margin: "0px 8px 0px 8px" }}>
                    <p className="error">
                      <pre
                        style={{
                          margin: 0,
                          fontSize: "0.8rem",
                          padding: 0,
                          color: "#d32f2f",
                          fontWeight: 450,
                          fontFamily: [
                            "system-ui",
                            "-apple-system",
                            "Segoe UI",
                            "Roboto",
                            "Helvetica Neue",
                            "Arial",
                            "Noto Sans",
                            "Liberation Sans",
                            "sans-serif",
                            "Apple Color Emoji",
                            "Segoe UI Emoji",
                            "Segoe UI Symbol",
                            "Noto Color Emoji",
                          ].join(","),
                        }}
                      >
                        {props.errorState.bankAccountError[1]}
                      </pre>
                    </p>
                  </div>
                )}
                <BalanceTransfer
                  screenMode={props.screenMode}
                  disbursementDetailTabValue={props.disbursementDetailTabValue}
                  errordispatchEvent={props.errordispatchEvent}
                  errorParameters={props.errorParameters}
                  validateBalanceTransferGrid={
                    props.validateBalanceTransferGrid
                  }
                />
              </Paper>
            </Box>
          </Box>
        </div>
      }
      <Snackbar
        open={alert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default DisbursementDetailsTab;
